import { render, staticRenderFns } from "./PillarItem.vue?vue&type=template&id=70aadc4d&scoped=true&"
import script from "./PillarItem.vue?vue&type=script&lang=js&"
export * from "./PillarItem.vue?vue&type=script&lang=js&"
import style0 from "./PillarItem.vue?vue&type=style&index=0&id=70aadc4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aadc4d",
  null
  
)

export default component.exports